const evalScenes = {
  evalTraining: 'eval_training0',
  evalSelection: 'eval_selection0',
  evalInventory: 'eval_inventory0',
  evalSocialRecruitment: 'eval_socialRecruitment0',
  evalCampusRecruiting: 'eval_campusRecruiting0'
};

const evalProject = {
  evalProjectListGet: 'eval_project_list_get0'
};

export default {
  ...evalScenes,
  ...evalProject,
  data: {
    eval_tools_list_get_extent: 'eval_tools_list_get_extent', // 问卷获取范围
    eval_project_evaluated_add_extent: 'eval_project_evaluated_add_extent', // 选择人员范围
    eval_project_list_get_extent: 'eval_project_list_get_extent', // 获取测评方案列表范围
    eval_scenes_evaluated_add_extent: 'eval_scenes_evaluated_add_extent' // 选择被评估人范围
  }
};
